/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_WhyInputs */

const en_header_why = /** @type {(inputs: Header_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why this matters`)
};

/**
* | output |
* | --- |
* | "Why this matters" |
*
* @param {Header_WhyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_why = /** @type {((inputs?: Header_WhyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_WhyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_why(inputs)
});